import { makeStyles } from "@mui/styles";
import { APP_COLORS } from "../../../../enums";

export const useMeetingRescheduleDrawerStyles = makeStyles({
  footerButtonSecondary: {
    "@media (min-width:600px)": {
      width: 160,
    },
  },
  footerButtonNext: {
    "@media (min-width:600px)": {
      width: 160,
    },
  },
  footerButtonSubmit: {
    "@media (min-width:600px)": {
      width: 200,
    },
  },
  noteAlert: {
    fontSize: "0.875rem",
  },
  reasonSummary: {
    padding: "8px 12px",
    borderRadius: 8,
    backgroundColor: APP_COLORS.greyLight,
    border: `1px solid ${APP_COLORS.greyLight3}`,
  },
});
